/**
 * GENERATED by `node scripts/generate-w-writer-manifest.js` from `wWriterRegistry.ts`. Do not edit.
 *
 * The compiled-in coverage manifest the stage-3 write seam reads: a bundle may enter Supabase-master
 * mode only when `allConverted` is true (design `write-cutover-stage3-app-seam.md` §1). A writer counts
 * as converted only when the registry test proves every W write it makes goes through `writeW`
 * (`writeWBypassProblems`, stage-3 P4); `global/Write/writeWCapability.ts` derives the capability from it.
 * `scripts/__tests__/wWriterRegistry.test.js` fails when this file and the registry disagree.
 */
import type { WWriterManifest } from './wWriterRegistry'

export const W_WRITER_MANIFEST: WWriterManifest = {
  "total": 83,
  "converted": 10,
  "allConverted": false,
  "byGroup": {
    "sales-returns": {
      "total": 8,
      "converted": 6
    },
    "complex-sales": {
      "total": 10,
      "converted": 0
    },
    "money": {
      "total": 10,
      "converted": 4
    },
    "working-hours-salary": {
      "total": 6,
      "converted": 0
    },
    "inventory": {
      "total": 12,
      "converted": 0
    },
    "purchasing": {
      "total": 6,
      "converted": 0
    },
    "products-catalogue": {
      "total": 22,
      "converted": 0
    },
    "clients": {
      "total": 4,
      "converted": 0
    },
    "stores": {
      "total": 5,
      "converted": 0
    }
  },
  "unconverted": [
    "global/Firebase/clients.ts#addNewClient",
    "global/Firebase/clients.ts#deleteClient",
    "global/Firebase/clients.ts#updateBonusForClient",
    "global/Firebase/clients.ts#updateClient",
    "global/Firebase/firebase.ts#addComplexSaleComment",
    "global/Firebase/firebase.ts#addComplexSalePayment",
    "global/Firebase/firebase.ts#deleteAllProducts",
    "global/Firebase/firebase.ts#deleteComplexSale",
    "global/Firebase/firebase.ts#deleteComplexSaleComment",
    "global/Firebase/firebase.ts#deleteComplexSalePayment",
    "global/Firebase/firebase.ts#deleteManufacture",
    "global/Firebase/firebase.ts#deleteMovement",
    "global/Firebase/firebase.ts#deleteProductCategory",
    "global/Firebase/firebase.ts#deleteProductModifiers",
    "global/Firebase/firebase.ts#deleteRecurringSpending",
    "global/Firebase/firebase.ts#deleteSaleReturn",
    "global/Firebase/firebase.ts#deleteSpending",
    "global/Firebase/firebase.ts#deleteStore",
    "global/Firebase/firebase.ts#deleteSupplier",
    "global/Firebase/firebase.ts#deleteSupplyOrder",
    "global/Firebase/firebase.ts#deleteTransaction",
    "global/Firebase/firebase.ts#resetCollectionData",
    "global/Firebase/firebase.ts#resetMovementData",
    "global/Firebase/firebase.ts#resetProductStocks",
    "global/Firebase/firebase.ts#saveNewComplexSale",
    "global/Firebase/firebase.ts#saveNewManufacture",
    "global/Firebase/firebase.ts#saveNewPricingRevision",
    "global/Firebase/firebase.ts#saveNewProductCategory",
    "global/Firebase/firebase.ts#saveNewSpending",
    "global/Firebase/firebase.ts#saveNewStore",
    "global/Firebase/firebase.ts#saveNewSupplier",
    "global/Firebase/firebase.ts#saveNewSupplyOrder",
    "global/Firebase/firebase.ts#saveNewTransaction",
    "global/Firebase/firebase.ts#saveProductCategoriesOrder",
    "global/Firebase/firebase.ts#saveProductModifiers",
    "global/Firebase/firebase.ts#saveProductTag",
    "global/Firebase/firebase.ts#saveRecurringSpendings",
    "global/Firebase/firebase.ts#saveSaleReturn",
    "global/Firebase/firebase.ts#saveUpdatedFinalPriceForComplexSale",
    "global/Firebase/firebase.ts#saveUpdatedItemsForComplexSale",
    "global/Firebase/firebase.ts#updateComplexSale",
    "global/Firebase/firebase.ts#updateComplexSaleStatus",
    "global/Firebase/firebase.ts#updateMarketplaceSettings",
    "global/Firebase/firebase.ts#updateMovement",
    "global/Firebase/firebase.ts#updateProductCategory",
    "global/Firebase/firebase.ts#updateStockManually",
    "global/Firebase/firebase.ts#updateStore",
    "global/Firebase/firebase.ts#updateStoreTimezone",
    "global/Firebase/firebase.ts#updateStoreWiponCredentials",
    "global/Firebase/firebase.ts#updateSupplier",
    "global/Firebase/firebase.ts#updateSupplyOrder",
    "global/Firebase/inventory.ts#deleteRevision",
    "global/Firebase/inventory.ts#deleteSupply",
    "global/Firebase/inventory.ts#deleteTransfer",
    "global/Firebase/inventory.ts#deleteWriteOff",
    "global/Firebase/inventory.ts#saveNewRevision",
    "global/Firebase/inventory.ts#saveNewSupply",
    "global/Firebase/inventory.ts#saveNewTransfer",
    "global/Firebase/inventory.ts#saveNewWriteOff",
    "global/Firebase/inventory.ts#updateRevision",
    "global/Firebase/inventory.ts#updateSupply",
    "global/Firebase/products.ts#batchUpdateProducts",
    "global/Firebase/products.ts#deleteProduct",
    "global/Firebase/products.ts#saveNewProduct",
    "global/Firebase/products.ts#updateProduct",
    "global/Firebase/products.ts#updateStockManually",
    "global/Firebase/workingHours.ts#countEmployeeBonuses",
    "global/Firebase/workingHours.ts#deleteWorkingHourPaymentTransaction",
    "global/Firebase/workingHours.ts#deleteWorkingHours",
    "global/Firebase/workingHours.ts#recalculateUserSalaryAmounts",
    "global/Firebase/workingHours.ts#saveNewWorkingHourPaymentTransaction",
    "global/Firebase/workingHours.ts#saveWorkingHours",
    "screens/Settings/ResetDataScreen.js#ResetDataScreen"
  ],
  "registryDigest": "bceca4a1"
}
